<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item to="/home/teacherList">讲师介绍</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row v-loading="loading" :gutter="20" style="width: 1200px;margin: 20px auto 0 ">
      <el-col :span="6" v-for="item in teacherList" :key="item.id">
        <el-card style="border-radius: 8px;margin-bottom: 20px;">
          <div @mouseenter="mouseOver($event)"
               @click="toDetail(item)">
            <div class="image">
              <img width="100%" height="210px" style="object-fit:cover" :src="item.image">
            </div>
            <div style="padding: 14px;">
              <div>
                <span class="card-detail-info-title">{{item.name}}</span>
              </div>
              <div class="card-cour-hour">
                <span style="font-size: 14px;color: #666666;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                  简介：{{item.intro}}
                </span>
                <!--<span style="float: right; font-size: 16px;color: #FF0000"> ￥{{item.price}}</span>-->
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col style="text-align: center" v-if="total == 0">
        <img src="@/assets/img/none.png" width="400" height="400" alt="">
      </el-col>
    </el-row>

    <!-- 分页-->
    <div style="text-align: center;margin-bottom: 10px;">
      <el-pagination
          background
          layout="prev, pager, next"
          :page-size.sync="queryParams.size"
          :current-page.sync="queryParams.page"
          @current-change="getTeacherList"
          :total="total"
          v-if="total > 0">
      </el-pagination>
    </div>
  </div>

</template>

<script>
import { pageListTeacher } from '@/api/teacher'
export default {
  name: "teacherList",
  data() {
    return {
      loading: true,
      queryParams: {
        page: 1,
        size: 8,
        name: undefined,
        position: undefined,
      },
      teacherList: [],
      total: 0,  // 总页数
    }
  },
  methods: {
    mouseOver(event) {
      event.currentTarget.style.cursor='pointer'
    },
    async getTeacherList() {
      this.loading = true;
      const { content } = await pageListTeacher(this.queryParams)
      console.log(content)
      this.teacherList = content.records
      this.total = Math.ceil(content.total/content.size)
      this.loading = false
    },
    toDetail(item) {
      const params = {
        teacherId: item.id
      };
      let routeUrl = this.$router.resolve({ name: 'TeacherDetail', params: params });
      window.open(routeUrl.href, '_self');
    }
  },
  created() {
    this.getTeacherList()
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  min-width: 1200px;
  margin: 20px auto 0;
}
.image {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 75%; /*padding-bottom都可以*/
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.el-card >>> .el-card__body {
  padding: 0;
}
.el-card {
  transition: transform 0.3s ease-out;
  &:hover {
    transform: translateY(-8px);
  }
}
.card-cour-hour {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999;
}
.card-detail-info-title{
  line-height: 26px;
  overflow: hidden;
  text-overflow:ellipsis;
  word-break: break-all;
  display:-webkit-box;
  -webkit-line-clamp:1;
  -webkit-box-orient: vertical;
}
</style>



